enum ArrowColor {
  CONVOY,
  IMPLIED,
  IMPLIED_FOREIGN,
  MOVE,
  MOVE_FAILED,
  RETREAT,
  SUPPORT_HOLD,
  SUPPORT_MOVE,
  SUPPORT_HOLD_FAILED,
  SUPPORT_MOVE_FAILED,
  CONVOY_FAILED,
}

export default ArrowColor;
